import AdminRoadmapTable, { Errors, getColumnWidths } from './AdminRoadmapTable';

export { Errors, getColumnWidths };

export default AdminRoadmapTable;
